import type {FilenameSchemaEntry} from "#material-outputs-filenames/types"
import {schemas as kravetSchemas} from "#material-outputs-filenames/schemas/kravet"

export const organizationName = "lee jofa" as const

// lee jofa uses the same schemas as kravet, so we can just re-export them here
export const schemas: FilenameSchemaEntry[] = [...kravetSchemas]
